import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63a0beb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "dashboard-graph-component"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "graph-container" }
const _hoisted_4 = {
  key: 0,
  class: "belts"
}
const _hoisted_5 = { class: "belts-inner" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Belt", -1 /* HOISTED */))
const _hoisted_7 = { class: "graph-year-labels" }
const _hoisted_8 = { class: "toggles" }
const _hoisted_9 = ["data-activty-style", "data-activty-id", "onClick"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "You've no dashboard data yet.", -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Add a cluster above and start logging your activities!", -1 /* HOISTED */))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "loading-placeholder"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "See your data on a deivce with at least 1180px", -1 /* HOISTED */))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Bar = _resolveComponent("Bar")!

  return (_ctx.windowBigEnough)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.activities.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Bar, {
                  ref: "chartRef",
                  data: _ctx.chartData.data,
                  options: _ctx.chartData.options,
                  height: 200
                }, null, 8 /* PROPS */, ["data", "options"]),
                (_ctx.belts.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.belts, (belt) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: belt.color,
                              style: _normalizeStyle({
									width: belt.percent + '%',
									backgroundColor: belt.color,
								})
                            }, null, 4 /* STYLE */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels.years, (label, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: label.year,
                    style: _normalizeStyle({
						width: label.width + '%',
					}),
                    class: _normalizeClass({
						'cutoff-start': (!label.isFullYear && i === 0),
						'cutoff-end': (!label.isFullYear && (i === (_ctx.labels.years.length -1))),
					})
                  }, [
                    _createElementVNode("span", null, _toDisplayString(label.year), 1 /* TEXT */)
                  ], 6 /* CLASS, STYLE */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toggles, (toggle) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: toggle.ID + toggle.ActivityStyle,
                    "data-activty-style": toggle.ActivityStyle,
                    "data-activty-id": toggle.ID,
                    class: _normalizeClass({ 'active': !toggle.hidden }),
                    role: "button",
                    onClick: ($event: any) => (_ctx.toggleDataSet(toggle))
                  }, _toDisplayString(toggle.DisplayName), 11 /* TEXT, CLASS, PROPS */, _hoisted_9))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, " Loading... "))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
}